// src/context/contextErrorCopy.js — OUR sentence for a refused Knowledge Base / persona / site request.
//
// ⛔ Never the server's message: `buildApiError` passes it through for any code it does not know, and it is
// English. `parseApiError` localises a few known codes into `err.message`, but reading `err.message` would still
// leak every other one — so the copy is chosen here, from `err.code` / `err.status`.
//
// Order: a code with FE copy (errors:context.<CODE>) → that copy; a 403 that is a plain write denial → "admin
// only"; a 5xx carrying `requestId` → the reference; no response at all → network; else the caller's sentence,
// printing the code (a support handle). The caller names its three keys (`server` takes {{ref}}, `generic`
// takes {{code}}), so each screen keeps its own wording. Billing refusals (402 family → RunRefusalNotice) are
// routed by the caller before this is asked.

/** The FE sentence for a code we know (or a plain write denial), else null. */
export function knownContextCopy(t, err) {
  const code = err?.code;
  if (code) {
    const own = t(`errors:context.${code}`, { defaultValue: '' });
    if (own) return own;
  }
  if (err?.status === 403 && (!code || code === 'TENANT_ADMIN_REQUIRED')) return t('errors:context.adminOnly');
  return null;
}

export function contextErrorCopy(t, err, { server, network, generic }) {
  const known = knownContextCopy(t, err);
  if (known) return known;
  if (typeof err?.status === 'number' && err.status >= 500 && err.requestId) {
    return t(server, { ref: err.requestId });
  }
  if (!err || err.status == null) return t(network);
  return t(generic, { code: err?.code || err.status });
}
